import useTableRequest from "../../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { productsReportsColumns } from "../../../constant/tables-columns/tablesColums";
import { digitsThree } from "../../../utils/price";
import ProductsReportsFilter from "./ProductsReportsFilter";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import moment from "jalali-moment";
import DateInput from "../../../components/common/inputs/DateInput";
import { convertDate } from "../../../utils/convertDate";

export default function ProductsReports() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [reportsData, setReportsData] = useState([]);

  const getProductReports = async (params) => {
    const path = "admin/reports/productPurchase";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setReportsData(response?.data?.result);
    });
  };

  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  const data = [];

  reportsData?.forEach((item) =>
    data.push({
      ...item,
      name: item.name,
      basePrice: digitsThree(item?.basePrice),
      buyPrice: digitsThree(item?.buyPrice),
      totalPrice: digitsThree(item?.totalPrice),
      total: digitsThree(item.total),
      createdAt: convertDate(item.createdAt),
      productSku: item?.productSku || "-",
      id: item._id,
    })
  );

  const exportReportsData = [];

  reportsData?.forEach((item) =>
    exportReportsData.push({
      نام: item.name,
      "قیمت فروش": item?.basePrice || "ندارد",
      "قیمت خرید": item?.buyPrice || "ندارد",
      "مجموع قیمت": item?.totalPrice || "ندارد",
      تعداد: item.total,
      شناسه: item?.productSku || "-",
      "تاریخ ایجاد": convertDate(item?.createdAt) || "-",
    })
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"گزاشات محصولات"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel disabled={tableRequest.status !== "success"} jsonData={exportReportsData} />
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">تعداد خرید هر محصول و قیمت‌های فعلی آن را در بازهٔ تاریخ پرداخت نشان می‌دهد. می‌توانید بر اساس SKU، نقش و کاربر فیلتر کنید.</p>
      <ProductsReportsFilter filterDataHandler={filterDataHandler} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={productsReportsColumns} rows={data} />
    </div>
  );
}
